import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  width: '27rem',
  height: 'auto',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  rowGap: '2rem',

  color: theme.colors.base01,

  textAlign: 'center',
}));

export const IconContainer = styled('div')({
  width: '8rem',
  height: '8rem',

  '& > svg': {
    width: '8rem',
    height: '8rem',
  },
});

export const Base02TextContainer = styled('div')(({ theme }) => ({
  marginTop: '-1.2rem',
  color: theme.colors.base02,
}));

export const DefaultStakingContainer = styled('div')({
  height: '55rem',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});
